/*
 * The HERE Maps SDK, loaded once and shared by every screen that draws a map.
 *
 * EXTRACTED RATHER THAN COPIED. The asset list carries subresource-integrity hashes that a
 * test asserts against the design document; a second copy would be a second thing to update
 * on a version bump, and the one nobody updates is the one that breaks.
 */

// THE APPROVED HERE ASSETS. These URLs and hashes are recorded in
// docs/specs/design/vehicle-location-poc.md and asserted against this file by
// fleetlocation/tests/test_frontend_template.py -- so a wrong-but-tidy edit here fails a
// test rather than shipping.
//
// Pinned to an EXACT version, never the 3.1 channel: that channel's contents change with
// every HERE release, so a hash against it would be wrong the moment they ship, and a hash
// that is expected to break teaches everyone to delete it.
//
// crossOrigin='anonymous' on every tag, because without it the browser does not check the
// integrity attribute at all on a cross-origin script and the hash is decoration.
const HERE_SCRIPTS = [
  {
    src: 'https://js.api.here.com/v3/3.1.69.2/mapsjs-core.js',
    integrity: 'sha384-TORskkwsbHXJyKqekcNHdMFXo3xAhVy4tFNPbKxvYbRW1fg7litkz5P+BmzTLs5v',
  },
  {
    src: 'https://js.api.here.com/v3/3.1.69.2/mapsjs-service.js',
    integrity: 'sha384-F11SLzPndBR3zeEMwb7ykNgGVjfgJ76D6ebqqZv03Cs+um8ESg2BitpmgDCmKQSb',
  },
  {
    src: 'https://js.api.here.com/v3/3.1.69.2/mapsjs-mapevents.js',
    integrity: 'sha384-hj7TpJ2FmlHVpMFYrkZVbpDCDvwL8mOpweqULLYuZ34YK+M06UaV5reYGShqrclt',
  },
  {
    src: 'https://js.api.here.com/v3/3.1.69.2/mapsjs-ui.js',
    integrity: 'sha384-aZXuHtYUQU9hC+jwuhUFYj4xCclUvfSSIQX2gbc7Jaa3lqFgWQIa/A8s6/fnus3/',
  },
];
const HERE_CSS = {
  href: 'https://js.api.here.com/v3/3.1.69.2/mapsjs-ui.css',
  integrity: 'sha384-vmjSVPiIwyjg1Y26kz9jjq6FTiNl1uFU0+vAx/HtLDIsp3wDSA2w3vExzV+OokOL',
};
let hereSdkPromise = null;

function loadScript(asset) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src="' + asset.src + '"]');
    if (existing) {
      resolve();
      return;
    }
    const el = document.createElement('script');
    el.src = asset.src;
    el.integrity = asset.integrity;
    el.crossOrigin = 'anonymous';
    el.async = false; // preserve order; HERE modules depend on core
    el.onload = resolve;
    el.onerror = () => {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      reject(new Error('failed to load ' + asset.src));
    };
    document.head.appendChild(el);
  });
}

async function loadHereAssets() {
  if (!document.querySelector('link[href="' + HERE_CSS.href + '"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = HERE_CSS.href;
    link.integrity = HERE_CSS.integrity;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }
  for (let i = 0; i < HERE_SCRIPTS.length; i += 1) {
    await loadScript(HERE_SCRIPTS[i]);
  }
}

function loadHereSdk() {
  // Share the whole ordered load so no caller skips an inserted but still-loading module.
  if (!hereSdkPromise) {
    hereSdkPromise = loadHereAssets().catch((error) => {
      // Reset before callers' rejection handlers can start a fresh attempt.
      hereSdkPromise = null;
      throw error;
    });
  }
  return hereSdkPromise;
}


export { loadHereSdk, HERE_SCRIPTS, HERE_CSS };
